import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import Config from '@/utils/config';
import authService from '@/services/auth';
import JsonEditor from 'vue-json-edit';
Vue.config.productionTip = false;
Vue.use(JsonEditor);

// eslint-disable-next-line no-unused-vars
import role from '@/directives/role';

// Vue.use(auth)
Config.loadConfiguration()
  .then(config => {
    authService.initAuthentication();
    store.dispatch('authentication/initAuthentication').then(() => {
      Vue.prototype.$config = config;
      new Vue({
        router,
        store,
        vuetify,
        render: h => h(App)
      }).$mount('#app');
    });
  })
  .catch(err => {
    throw err;
  });
